/* unplugin-vue-components disabled */import { render } from "./add-prompt.vue?vue&type=template&id=4ec45165&scoped=true"
import script from "./add-prompt.vue?vue&type=script&lang=js"
export * from "./add-prompt.vue?vue&type=script&lang=js"

import "./add-prompt.vue?vue&type=style&index=0&id=4ec45165&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec45165"],['__file',"src/components/prompts-v2/add-prompt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ec45165"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ec45165', __exports__)) {
    api.reload('4ec45165', __exports__)
  }
  
  module.hot.accept("./add-prompt.vue?vue&type=template&id=4ec45165&scoped=true", () => {
    api.rerender('4ec45165', render)
  })

}


export default __exports__